var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, IconButton, Icon, Heading } from 'shared/components';
import { Close } from 'shared/assets/icons';
import { usePowerPanelContext } from '../contexts';
export var PowerPanelHeader = function () {
    var _a = usePowerPanelContext(), onClose = _a.onClose, header = _a.header, HeaderContainer = _a.headerContainer;
    return (_jsx(HeaderContainer, { children: _jsxs(Flex, __assign({ justify: "space-between", align: "center", flexShrink: 0 }, { children: [_jsx(Heading, __assign({ size: "heading-small" }, { children: header })), _jsx(IconButton, { variant: "unstyled", "aria-label": "Close Power Panel", icon: _jsx(Icon, { as: Close, boxSize: 4 }), pt: 2, size: "small", onClick: onClose })] })) }));
};
